import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentFrom from "../../components/contentfrom";

function Gettouch(props) {
  return (
    <div className="gettouch p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="example" data-text="Conect">
              <h2>Let’s talk about your project</h2>
            </div>
            <p>
              Ready to turn your gaming vision into reality? Let's start the
              journey towards the development of a next-gen game that sets a
              trend in the market. We follow a personalized approach to every
              project as it is unique in its own ideation. With our professional
              team of experts by your side, we ensure that your game project
              will receive the utmost care, attention, and expertise it
              deserves. Let's discuss your game project today and take the first
              step towards creating a gaming experience that will revolutionize
              the gaming experience, leading towards the optimal business.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-lg-1"
          >
            <ContentFrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Gettouch;
